import { gql } from '@apollo/client';

export const SWITCH_VENUE = gql`
    mutation SwitchVenue($venueId: String!) {
        switchVenue(venueId: $venueId) 
    }
`;